import { Typography, useTheme } from "@mui/material";
import FlexBetween from "../../components/FlexBetween";
import WidgetWrapper from "../../components/WidgetWrapper";

const AdvertWidget = () => {
	const { palette } = useTheme();
	const dark = palette.neutral.dark;
	const main = palette.neutral.main;
	const medium = palette.neutral.medium;

	return (
		<WidgetWrapper>
			<FlexBetween>
				<Typography color={dark} variant='h5' fontWeight='500'>
					Sponsored
				</Typography>
				<Typography
					sx={{
						"&:hover": { cursor: "pointer" },
					}}
					color={medium}
				>
					Create Ad
				</Typography>
			</FlexBetween>
			<img
				width='100%'
				height='auto'
				alt='advert'
				src='https://laneway-hub-server.onrender.com/uploads/sponsored.jpeg'
				style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
			/>
			<FlexBetween>
				<Typography color={main}>Arasaka Corporation</Typography>
				<Typography
					sx={{
						"&:hover": { cursor: "pointer" },
					}}
					color={medium}
				>
					arasakacorporation.com
				</Typography>
			</FlexBetween>
			<Typography color={medium} m='0.5rem 0'>
				Shaping the Future, One Innovation at a Time.
			</Typography>
		</WidgetWrapper>
	);
};

export default AdvertWidget;
